import { render, staticRenderFns } from "./AlarmCenterMonitorListDyw.vue?vue&type=template&id=b71c7b38&scoped=true"
import script from "./AlarmCenterMonitorListDyw.vue?vue&type=script&lang=js"
export * from "./AlarmCenterMonitorListDyw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71c7b38",
  null
  
)

export default component.exports